import axios, { AxiosResponse } from "axios";
import { UserModel } from "..";
import { useMutation } from "react-query";
import { bareAxios } from "./AuthHelpers";

export const GET_USER_BY_ACCESSTOKEN_URL = `/api/profile/`;

export const SET_AUTH_CODE = `/api/auth/code/`;

export const LOGOUT = `/api/auth/logout/`;

// Повторная верификация сессии — для всего состава панели, а не только для
// admin/moderator/support, как было в первой версии.
export const REVERIFY_REQUEST = `/api/auth/reverify/request`;
export const REVERIFY_CONFIRM = `/api/auth/reverify/confirm`;
export const REVERIFY_LOCK = `/api/auth/reverify/lock`;

export async function getUserByToken(): Promise<UserModel> {
  const response = await axios.get<UserModel>(GET_USER_BY_ACCESSTOKEN_URL);
  return response.data;
}

export const useSetAuthCode = () => {
  return useMutation("set-auth-code", async (code: string) => {
    const { data: response } = await axios.post(SET_AUTH_CODE, {
      code,
    });
    return response;
  });
};

// Реальный логаут: сервер отзывает сессию и чистит cookie (PIN/lock больше нет).
export const useAuthLogout = () => {
  return useMutation("logout", async () => {
    const { data: response } = await axios.post(LOGOUT, {});
    return response;
  });
};

// --- Повторная верификация ---------------------------------------------------
// Все запросы идут через bareAxios (без 401-интерцептора) и с validateStatus:
// коды 409/429 — часть штатного контракта, а не сетевые ошибки, поэтому их
// разбирает вызывающий код по res.status / res.data.code.

const passthrough = { validateStatus: () => true };

// Просим сервер отправить одноразовый код в Telegram.
// 200 { expires_in } | 409 reverify_telegram_required | 429 reverify_blocked
export async function reverifyRequest(): Promise<AxiosResponse> {
  return bareAxios.post(REVERIFY_REQUEST, {}, passthrough);
}

// Подтверждаем код из Telegram.
// 200 { verified: true } | 409 reverify_invalid | 429 reverify_blocked
export async function reverifyConfirm(code: string): Promise<AxiosResponse> {
  return bareAxios.post(REVERIFY_CONFIRM, { code }, passthrough);
}

// Запираем сессию досрочно: человек отошёл от панели, хотя вкладка продолжает
// опрашивать API. Бэк сам такого простоя не увидит — окно активности продлевает
// ЛЮБОЙ запрос, включая фоновый поллинг карточек. Идемпотентна.
// 200 { locked: true }
export async function reverifyLock(): Promise<AxiosResponse> {
  return bareAxios.post(REVERIFY_LOCK, {}, passthrough);
}

